import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'

import './styles.scss'

function Slider ({ children }) {
  const [page, setPage] = useState(1)

  const slidesRef = useRef(null)
  const slidesContainerRef = useRef(null)

  const numberOfPages = React.Children.count(children)
  const pages = Math.min(3, Math.ceil(numberOfPages / 5))

  const moveToPage = page => {
    const position = slidesRef.current.clientWidth * (page - 1)
    const hasRtl = document.querySelector('html').className === 'has-rtl'

    if (hasRtl) {
      slidesContainerRef.current.style.marginRight = `${-position}px`
    } else {
      slidesContainerRef.current.style.marginLeft = `${-position}px`
    }
  }

  const moveLeft = event => {
    event.preventDefault()

    if (page > 1) {
      setPage(page - 1)
      moveToPage(page - 1)
    }
  }

  const moveRight = event => {
    event.preventDefault()

    if (page < pages) {
      setPage(page + 1)
      moveToPage(page + 1)
    }
  }

  return (
    <div id='slider'>
      <div className='slider-wrapper'>
        <a
          className={'left-arrow' + (page === 1 ? ' inactive' : '')}
          onClick={moveLeft}
          href='#'
          aria-label='Move left'
        />
        <div className='slides' ref={slidesRef}>
          <div className='slides-container' ref={slidesContainerRef}>
            {children}
          </div>
        </div>
        <a
          className={'right-arrow' + (page === pages ? ' inactive' : '')}
          onClick={moveRight}
          href='#'
          aria-label='Move Right'
        />
      </div>
    </div>
  )
}

export default Slider

Slider.propTypes = {
  children: PropTypes.node
}
